/* import __COLOCATED_TEMPLATE__ from './card-status-details.hbs'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { addressEntry } from '@banking/ui/utils/address';
import { isCardDelivered, isCardActivatable, isAccountOwnerCard, hasExpiringCardScheduledReplacementDate, hasCardReplacement, isCardExpired, isCardExpiring, isInactiveCard } from '@banking/ui/utils/card-settings-utils';
import { convertYearMonthDayToDate } from '@banking/ui/utils/datetime-converter';
import { getCardholder } from '@banking/ui/utils/card/card';
export let CardStatusSection = /*#__PURE__*/function (CardStatusSection) {
  CardStatusSection["REPLACEMENT_CARD_PRE_ISSUANCE"] = "REPLACEMENT_CARD_PRE_ISSUANCE";
  CardStatusSection["CARD_EXPIRED_REPLACEMENT_CARD_ISSUED"] = "CARD_EXPIRED_REPLACEMENT_CARD_ISSUED";
  CardStatusSection["CARD_EXPIRING_REPLACEMENT_CARD_ISSUED"] = "CARD_EXPIRING_REPLACEMENT_CARD_ISSUED";
  CardStatusSection["CARD_DELIVERED"] = "CARD_DELIVERED";
  CardStatusSection["CARD_PRE_DELIVERY"] = "CARD_PRE_DELIVERY";
  return CardStatusSection;
}({});
let CardStatusDetails = (_class = class CardStatusDetails extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "CardStatusSection", CardStatusSection);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "sentry", _descriptor2, this);
  }
  get cardStatusSectionType() {
    const card = this.args.card;

    // prioritizing expired cards first because expired cards would be all the
    // conditions of `CARD_DELIVERED` except isCardActivatable.
    // This way we do not have to access the card for those three conditions
    if (hasCardReplacement(card)) {
      if (isCardExpired(card)) {
        return CardStatusSection.CARD_EXPIRED_REPLACEMENT_CARD_ISSUED;
      }
      if (isCardExpiring(card)) {
        return CardStatusSection.CARD_EXPIRING_REPLACEMENT_CARD_ISSUED;
      }
    }
    if (hasExpiringCardScheduledReplacementDate(card)) {
      return CardStatusSection.REPLACEMENT_CARD_PRE_ISSUANCE;
    }
    if (isCardDelivered(card) && isCardActivatable(card) && isAccountOwnerCard(card)) {
      if (!this.formattedFulfillmentAddress) {
        this.sentry.captureException('Card settings: Missing fulfillment address for delivered card');
        return null;
      }
      return CardStatusSection.CARD_DELIVERED;
    }
    if (!isCardDelivered(card) && isInactiveCard(card) && this.shippingText) {
      return CardStatusSection.CARD_PRE_DELIVERY;
    }
    return null;
  }
  get formattedBillingAddress() {
    const billingAddress = this.args.billingAddress;
    return billingAddress ? addressEntry(billingAddress, {
      hideCountryCode: true
    }) : null;
  }
  get formattedFulfillmentAddress() {
    const fulfillmentAddress = this.args.card?.fulfillment?.address;
    return fulfillmentAddress ? addressEntry(fulfillmentAddress, {
      hideCountryCode: true
    }) : null;
  }
  get replacementCardIssueDate() {
    const scheduledIssueDate = this.args.card.expirationData?.replacementCard?.scheduledIssueDate;
    if (!scheduledIssueDate) {
      this.sentry.captureException('Card settings: Missing replacement card issue date');
      return '';
    }
    return this.intl.formatDate(convertYearMonthDayToDate(scheduledIssueDate), {
      format: 'monthDay'
    });
  }
  get shippingText() {
    const card = this.args.card;
    const deliveryDate = card.fulfillment?.deliveryDate;
    if (!deliveryDate) {
      this.sentry.captureException('Card settings: Missing delivery date');
      return '';
    }
    const formattedDeliveryDate = this.intl.formatDate(convertYearMonthDayToDate(deliveryDate), {
      format: 'monthDay'
    });
    const cardholder = getCardholder(this.args.card);
    if (isAccountOwnerCard(this.args.card)) {
      return this.intl.t('banking.checking.cardSettings.page.status.shipping.text.owner', {
        date: formattedDeliveryDate
      });
    } else if (cardholder.length > 0) {
      return this.intl.t('banking.checking.cardSettings.page.status.shipping.text.authorizedUser', {
        cardholder,
        date: formattedDeliveryDate
      });
    } else {
      this.sentry.captureException('Card settings: cardholder name must exist');
      return '';
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { CardStatusDetails as default };